import { string } from './type-checkers.js';
import { wrapType } from './util.js';
const color = wrapType(string, { type: 'color' });
export { color, };
//# sourceMappingURL=color.js.map